import React from 'react';
import { LandingHeader } from '../components/landing/LandingHeader';
import { Hero } from '../components/landing/Hero';
import { Problem } from '../components/landing/Problem';
import { Solution } from '../components/landing/Solution';
import { HowItWorks } from '../components/landing/HowItWorks';
import { DashboardPreview } from '../components/landing/DashboardPreview';
import { CallToAction } from '../components/landing/CallToAction';
import { LandingFooter } from '../components/landing/LandingFooter';

const LandingPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-white font-sans text-darkText antialiased selection:bg-green-100 selection:text-green-900">
      <LandingHeader />
      <main>
        <Hero />
        <Problem />
        <Solution />
        <HowItWorks />
        <DashboardPreview />
        <CallToAction />
      </main>
      <LandingFooter />
    </div>
  );
};

export default LandingPage;
